import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

import {
  getWithdrawDetails,
  createWithdraw,
  IWithdrawDetails
} from '@/modules/transaction/services/variable-income';

import {
  VariableIncomeWithdrawComponents,
  EVariableIncomeWithdrawSteps
} from './helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariableIncomeWithdraw',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const currentStep = ref(EVariableIncomeWithdrawSteps.INVESTMENT);
const withdrawDetails = ref<IWithdrawDetails>();
const amountFormatted = ref('');
const amountValue = ref(0);

const isLoading = ref(true);
const hasError = ref(false);
const isFetchingWithdraw = ref(false);

const portfolioId = computed(() => {
  return route.params.id as string;
});

const step = computed(() => {
  return {
    component: VariableIncomeWithdrawComponents[currentStep.value]
  };
});

const showNavbar = computed(() => {
  return currentStep.value !== EVariableIncomeWithdrawSteps.CONCLUSION;
});

const portfolioName = computed(() => {
  return withdrawDetails.value?.portfolioName ?? '';
});

function backStep() {
  if (currentStep.value === EVariableIncomeWithdrawSteps.INVESTMENT) {
    router.push({
      name: 'wealthIndexPortfolio',
      params: { portfolioId: portfolioId.value }
    });

    return;
  }

  currentStep.value = currentStep.value - 1;
}

function changeAmountValue(value: number, formatted: string) {
  amountValue.value = value;
  amountFormatted.value = formatted;

  currentStep.value = EVariableIncomeWithdrawSteps.PREVIEW;
}

async function fetchWithdrawDetails() {
  try {
    isLoading.value = true;
    hasError.value = false;

    withdrawDetails.value = await getWithdrawDetails(portfolioId.value);
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchWithdraw() {
  try {
    isFetchingWithdraw.value = true;

    await createWithdraw(portfolioId.value, amountValue.value);

    currentStep.value = EVariableIncomeWithdrawSteps.CONCLUSION;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível fazer o resgate. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isFetchingWithdraw.value = false;
  }
}

onMounted(() => {
  fetchWithdrawDetails();
});

provide('withdrawDetails', withdrawDetails);
provide('isFetchingWithdraw', isFetchingWithdraw);
provide('amountFormatted', amountFormatted);
provide('amountValue', amountValue);
provide('portfolioId', portfolioId);

provide('fetchWithdraw', fetchWithdraw);
provide('changeAmountValue', changeAmountValue);

return { __sfc: true,route, router, currentStep, withdrawDetails, amountFormatted, amountValue, isLoading, hasError, isFetchingWithdraw, portfolioId, step, showNavbar, portfolioName, backStep, changeAmountValue, fetchWithdrawDetails, fetchWithdraw, NavBar, LoaderIndicator, HelperViewStatus, BackButton, FadeTransition }
}

})